import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  private cache = new Map<string, HttpResponse<any>>();
  constructor(
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.method !== 'GET') {
      this.cache.clear(); // Clear cache on non-GET requests
      return next.handle(request);
    }

    if (request.url.match(/sv=/)) {
      return next.handle(request);
    } else {
      let accessToken = sessionStorage.getItem('accessToken') ? sessionStorage.getItem('accessToken')
        : localStorage.getItem('accessToken');
      //if (this._userDataService.tokenData && this._userDataService.tokenData['accessToken']) {
      if (accessToken) {
        request = request.clone({
          setHeaders: {
            'X-Frame-Options': 'SAMEORIGIN',
            'X-Content-Type-Options': 'nosniff',
            'Strict-Transport-Security': 'max-age=31536000',
            'Content-Security-Policy': 'default-src \'self\'',
            'Referrer-Policy': 'same-origin',
            'Permissions-Policy': 'geolocation=(self)',
            'Cross-Origin-Embedder-Policy': 'require-corp',
            'Cross-Origin-Resource-Policy': 'same-origin',
            'Cross-Origin-Opener-Policy': 'same-origin',
            Authorization: `Bearer ${accessToken}`
          }
        });
      } // IF
      return next.handle(request);
    }
  } // INTERCEPT
} // EXPORT
